import {
  has, trim, isNumber,
} from 'lodash-es';
import Raven from 'raven-js';
import Cookies from 'js-cookie';
import { getAnswerKey } from '@/utils/helper';
import ValidateError from './ValidateError';
import { getDisplaySubTitles, isMatrixRange, isMatrix } from '../questionHelper';
import context from '../../../main';

export default {
  format(answer, sid) {
    if (answer && !has(answer, getAnswerKey(answer.type))) {
      Raven.setTagsContext({
        api: 'format_answer',
        sid,
        client_id: Cookies.get('survey_cid'),
      });
      Raven.setExtraContext({
        answer,
      });
      Raven.captureMessage('脏数据');
    }
    return true;
  },

  shouldKeep(question) {
    // 如果没有任何选项，则跳过判断
    let isJump = false;
    let notOptions = false;
    let notSubTitles = false;
    if (has(question, 'options') || has(question, 'additionOptions')) {
      notOptions = !question?.options?.length && !question?.additionOptions?.length;
    }
    if (isMatrix(question)) {
      if (has(question, 'subTitles') || has(question, 'additionSubTitles')) {
        notSubTitles = !question?.subTitles?.length && !question?.additionSubTitles?.length;
      }
      isJump = notSubTitles || notOptions;
    } else {
      isJump = notOptions;
    }

    return isJump;
  },

  required(answer, question) {
    const errText = context.$t('check_required');
    if (answer && answer.type.includes('attachment') && answer.options.some(o => !o.text)) {
      throw new ValidateError('文件上传中，请稍后');
    }
    if (answer && answer.type.includes('matrix')) {
      const subTitleIds = getDisplaySubTitles(question).map(s => s.id);
      for (let i = 0; i < subTitleIds.length; i++) {
        const subTitleId = subTitleIds[i];
        if (isMatrixRange(question)) {
          if (!isNumber(answer.groups[subTitleId])) {
            throw new ValidateError(errText, { subTitleId });
          }
        } else if (!answer.groups[subTitleId]?.length) {
          throw new ValidateError(errText, { subTitleId });
        }
      }
    } else if (!answer
      || (has(answer, 'blank') && !answer.options?.length)
      || (has(answer, 'options') && !answer.options.length)
      || (has(answer, 'text') && !trim(answer.text).length)
    ) {
      throw new ValidateError(errText);
    }

    return true;
  },

  blankRequired(answer, question, optionId) {
    if (!answer) {
      return true;
    }

    if (has(answer, 'options')) {
      const option = answer.options.find(o => o.id === optionId);

      if (!option) {
        return true;
      }

      if (trim(option.blankContent)) {
        return true;
      }

      throw new ValidateError('这个空必填');
    }

    if (has(answer, 'groups')) {
      Object.entries(answer.groups).forEach((item) => {
        const [subTitleId, options] = item;
        if (!options.every(o => (o.blankRequired ? !!trim(o.blankContent) : true))) {
          throw new ValidateError('这个空必填', { subTitleId });
        }
      });
      return true;
    }

    throw new ValidateError('这个空必填');
  },
};
